export default "__VITE_PUBLIC_ASSET__915dfba3__"